import { usePage } from "@inertiajs/react";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
import paginate from "simple-paginator";

export default function () {
  if (import.meta.env.SSR) return null;

  const { total_pages, page } = usePage().props;
  const currentPage = Number(page) || 1;
  if (Number(total_pages) <= 1) return null;

  const paginator = paginate(Number(total_pages), currentPage, {
    offset: 2,
  });

  const newUrlWithPage = (page) => {
    const params = new URLSearchParams(document.location.search);
    params.set("page", page);
    return `?${params.toString()}`;
  };
  const {
    current,
    isFirst,
    isLast,
    nextPage,
    prevPage,
    prevPages,
    nextPages,
    displayPrevEllipsis,
    displayNextEllipsis,
  } = paginator;

  return (
    <div>
      <div className="flex xl:justify-between flex-wrap space-y-8 justify-center items-center py-8">
        <Pagination>
          <PaginationContent>
            {!isFirst && (
              <PaginationItem>
                <PaginationPrevious
                  except={["filters"]}
                  href={newUrlWithPage(prevPage)}
                />
              </PaginationItem>
            )}

            {displayPrevEllipsis && (
              <PaginationItem>
                <PaginationEllipsis />
              </PaginationItem>
            )}
            {prevPages.map((i) => (
              <PaginationItem>
                <PaginationLink
                  key={`prev-page-${i}`}
                  except={["filters"]}
                  href={newUrlWithPage(i)}
                >
                  {i}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem>
              <PaginationLink
                except={["filters"]}
                isActive
                href={newUrlWithPage(current)}
              >
                {current}
              </PaginationLink>
            </PaginationItem>

            {nextPages.map((i) => (
              <PaginationItem>
                <PaginationLink
                  key={`prev-page-${i}`}
                  except={["filters"]}
                  href={newUrlWithPage(i)}
                >
                  {i}
                </PaginationLink>
              </PaginationItem>
            ))}

            {displayNextEllipsis && (
              <PaginationItem>
                <PaginationEllipsis />
              </PaginationItem>
            )}

            {!isLast && (
              <PaginationItem>
                <PaginationNext
                  except={["filters"]}
                  href={newUrlWithPage(nextPage)}
                />
              </PaginationItem>
            )}
          </PaginationContent>
        </Pagination>
      </div>
    </div>
  );
}
